module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "/static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    key: _vm.headerKey,
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.is_logged_in) ? _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('p', [_vm._m(1), _vm._v(": "), _c('b', [_vm._v("\r\n                                    ₦" + _vm._s(_vm.formatCurrency(_vm.user.current_wallet_balance)))])])]) : _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Join Forum")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("Find CNpros ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "to": "/insuremoto"
    }
  }, [_vm._v("InsureMoto")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cnsurveys"
    }
  }, [_vm._v("Take CNsurveys")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/businesses"
    }
  }, [_vm._v("Find Businesses")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/how-it-works"
    }
  }, [_vm._v("How CNpro Works")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help-me-find-a-cnpro"
    }
  }, [_vm._v("Help Me Find A CNpro")])], 1), _vm._v(" "), (_vm.user != null && _vm.user != undefined && _vm.user != '') ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user.user_fullname) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Logout")])], 1)])], 1)] : [_c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1), _vm._v(" "), _c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]], 2), _vm._v(" "), _vm._m(3)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713e7952"}!./src/components/Second-Header/template.html
// module id = 303
// module chunks = 0